import { Builder } from '@builder.io/react'
import { LinkButtonRegisterProps } from 'components/ui-builder/common/button'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import { navigate } from 'gatsby'
import React from 'react'
import newSticker from '../../../images/newProduct.svg'
import ourRecipesImg from '../../../images/sidebar/sidebar-our-recipes.svg'
import { LinkButtonProp } from '../common/button'
import CustomHeading, { headingTypePropObj, headingClassPropObj } from '../common/heading'

interface Props {
  backgroundColor: string
  cloudinaryHeroImage: any
  builderHeroImage: any
  cloudinaryHeroImageAltText: string
  headingText: string
  headingTextColor: string
  contentText: string
  headingType: HeadingType
  headingClass: HeadingClass
  textAlignment: Alignment
  buttonEnabled: boolean
  buttonProp: LinkButtonProp
  mobileBannerHeader: string
  stickerEnabled: boolean
}

const RecipeOfTheMonth = ({
  backgroundColor,
  cloudinaryHeroImage,
  builderHeroImage,
  cloudinaryHeroImageAltText,
  headingText,
  headingTextColor,
  contentText,
  headingType,
  headingClass,
  textAlignment,
  buttonEnabled,
  buttonProp,
  mobileBannerHeader,
  stickerEnabled
}: Props) => {
  const renderImage = () => {
    return (
      <>
        {stickerEnabled && (
          <img className="absolute z-30 ml-6 lg:ml-3 inline-flex h-24 w-24" src={newSticker} alt="New" />
        )}
        <CdnImage
          className="index-2 relative mx-auto w-4/6 lg:w-full object-cover max-h-22 lg:h-72 rounded-[30px]"
          url={builderHeroImage}
          alt={cloudinaryHeroImageAltText}
          lazyLoad={false}
          steps={[1080]}
          width={'500'}
        />

        {/* {builderHeroImage ? (
          <CdnImage
            className="index-2 relative mx-auto w-4/6 lg:w-full object-cover max-h-22 lg:h-72 rounded-[30px]"
            url={builderHeroImage}
            alt={cloudinaryHeroImageAltText}
            lazyLoad={false}
            steps={[1080]}
            width={'500'}
          />
        ) : (
          <CloudinaryImage
            className="index-2 relative mx-auto w-4/6 lg:w-full object-cover max-h-22 lg:h-72 rounded-[30px]"
            publicId={cloudinaryHeroImage?.public_id}
            alt={cloudinaryHeroImageAltText}
            loading={'eager'}
            steps={[1080]}
            width={500}
          />
        )} */}
      </>
    )
  }
  const renderCTAButton = (buttonEnabled: boolean, buttonText: string) => {
    if (buttonEnabled) {
      return (
        <button
          className={`mx-auto flex w-full items-center justify-center rounded-full bg-[#006685] px-5 py-3 text-base font-medium text-white md:w-56 md:text-lg`}
          onClick={() => {
            if (typeof window.gtag !== 'undefined') {
              window.gtag('event', 'cta_recipe_of_the_month_add_recipe_cta_logged_in', {
                page: 'home_page_logged_in'
              })
            }
            navigate(`${buttonProp?.buttonUrl}`)
          }}
        >
          {buttonText}
        </button>
      )
    }

    return null
  }

  return (
    <div
      className="bg-image-none relative h-full w-full lg:w-10/12 mx-auto md:bg-cover md:bg-bottom md:bg-no-repeat xl:container"
      style={{ backgroundColor }}
    >
      <img className="w-11/12 mx-auto justify-center pt-6 lg:hidden" src={mobileBannerHeader} alt={'Our Recipes'} />
      <div className="flex flex-col lg:flex-row items-center mx-auto justify-center 2xl:px-0">
        <div
          className={`bg-[#F8F2EC] lg:rounded-l-2xl py-4 pb-8 lg:py-10 lg:pr-6 lg:pl-4 h-4/5 w-11/12 lg:w-auto flex flex-col justify-center items-center lg:items-start lg:justify-start`}
        >
          <div className="text-[#004355] text-2xl lg:text-3xl font-medium font-serif text-center lg:text-left lg:whitespace-nowrap">
            Chef’s Recipe
            <br />
            of the Month
          </div>
          <img className="hidden lg:block pt-6" src={ourRecipesImg} alt={'Our Recipes'} />
        </div>
        <div className="bg-[#F8F2EC] w-11/12 block lg:hidden"> {renderImage()}</div>
        <div className="hidden lg:block"> {renderImage()}</div>
        <div
          className={`bg-[#F8F2EC] w-11/12 lg:w-1/2 rounded-b-2xl lg:rounded-r-2xl lg:rounded-l-none py-6 px-2 lg:p-6 h-4/5 flex-col`}
        >
          <div className="w-full lg:w-[30rem] 2xl:w-[38rem] mx-auto lg:mr-auto lg:ml-6 flex flex-col justify-center items-center lg:items-start lg:justify-start">
            {' '}
            <CustomHeading
              classList="line-height-fix w-full h-full tracking-tight text-gray-900 font-medium text-center lg:text-left"
              headingClass={headingClass}
              headingType={headingType}
              color={headingTextColor}
            >
              {headingText}
            </CustomHeading>
            <p
              className={`line-height-fix w-11/12 2xl:w-full enable-list-styles text-base font-medium font-sans text-center lg:text-left my-4`}
              dangerouslySetInnerHTML={{ __html: contentText }}
            ></p>{' '}
            <div className="mx-auto lg:mr-auto lg:ml-0 flex justify-start items-start">
              {renderCTAButton(buttonEnabled, `${buttonProp.loggedInButtonText}`)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RecipeOfTheMonth
Builder.registerComponent(RecipeOfTheMonth, {
  name: 'RecipeOfTheMonth',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    // {
    //   name: 'cloudinaryHeroImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderHeroImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },

    {
      name: 'cloudinaryHeroImageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'contentText',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'left'
    },
    {
      name: 'buttonEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonProp'
    },
    {
      name: 'mobileBannerHeader',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'stickerEnabled',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
